// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/Aboutus.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./images/academic.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./images/adaptation.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./images/pedagogy.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./images/wellbeing.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./images/communication.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./images/personal.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./images/our_program_banner.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./images/a3_bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  max-width: 700px;
  width: 100%;
  margin: auto;
  padding: 30;
}
.container .form-data {
  width: 70%;
  border: 1px solid #dfdfdf;
  padding: 20px;
  border-radius: 5px;
  background: #fff;
}
.container .form-data .form-label {
  color: #000 !important;
}
pre {
  width: 70%;
  color: #fff;
  font-size: larger;
}
.Level{
  margin-left: .9rem;
  background-color: 'red';
}

button {
   background: #0563b4 !important; 
}
.form .field + p {
  color: red;
}

.goto_login {
  color: black;
}
.error-message {
  color: red;
  font-size: 12px;
}


.syllabus-settings-card {
  max-height: 80vh;
  overflow: scroll;
  top: 15px;
}
.popover_submenu {
  max-height: 500px;
  overflow: scroll;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
/* Hide scrollbar for Chrome, Safari and Opera */
.popover_submenu::-webkit-scrollbar, .chakra-card::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.chakra-card {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

.aboutus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 100%;
  height: 330px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.academic {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  width: 100%;
  height: 330px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.adaptation{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  width: 100%;
  height: 330px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.pedagogy {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  width: 100%;
  height: 330px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.wellbeing {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  width: 100%;
  height: 330px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}


.communication {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 100%;
  height: 330px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.personal {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  width: 100%;
  height: 330px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}


.overlay-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.video_tag {
  object-fit: initial;
  width: 100%;
  height: 55vh;
}

.header_menu::before {
  color: #757575;
  content: "\\2022";
  line-height: 1;
  position: absolute;
  top: 4px;
  left: -14px;
  font-size: 24px;
  pointer-events: none;
}

.submenu_icon::after{
  content: "\\00a0\\25BC";
  font-size: 0.69444rem;
}

.program {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  width: 100%;
  height: 330px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.footer-whatsapp {
  display: flex;
  align-items: center;
}
/* .footer {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
} */
/* Home  */
.homeComponent .home-content{
  font-size: 30px;
  text-align: center;
}
.logowithcontent{
margin: auto;
}
.logowithcontent p{
  font-weight: 600;
  font-size: 14px;
}
.logowithcontent img {
  width: 350px;
  margin: 12px auto;
}
.sub-heading{
font-size: 30px;
  font-weight: 600;
  margin-bottom: 15px;
}
.mission {
  width: 70%;
  letter-spacing: 1.5px;
  line-height: 1.6;
}
.vision {
  font-size: 36px;
  text-align: center;
  margin: auto;
  width: 90%;
  letter-spacing: 1.5px;
    line-height: 1.6;
}

.gray-block {
  font-size: 28px;
  text-align: center;
  margin: auto;
  width: 85%;
  /* height: 300px; */
  letter-spacing: 1.5px;
    line-height: 1.6;
}

.ped-block {
  font-size: 23px;
  text-align: center;
  margin: auto;
  width: 85%;
  height: 250px;
  letter-spacing: 1.5px;
    line-height: 1.6;
}


.imgBox {
  font-size: 36px;
  text-align: center;
  margin: auto;
  height: 60px;
  width: 70%;
  background-color: #000000;
  letter-spacing: 1.5px;  
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  font-weight: bold;
}


.imgBoxV2 {
  font-size: 36px;
  text-align: center;
  margin: auto;
  height: 60px;
  width: 90%;
  background-color: #000000;
  letter-spacing: 1.5px;  
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  font-weight: bold;
}

.progBox {
  font-size: 36px;
  text-align: center;
  margin: auto;

  /* height: 150px; */
  /* width: 72%; */

  background-color: #000000;
  
  letter-spacing: 1.5px;  
  /* display: inline-block; */
  vertical-align: middle;
}

.vision-section {
  background-color: #4c4c47;
  color: #fff;
}
.mission-points{
font-size: 14px;
}

.text-header {
  /* font-size: 50px !important; */
  letter-spacing: 2px !important;
  /* font-style: normal !important; */
}


element.style {
}
.site-header > *:last-child, .entry-header > *:last-child, .post-thumbnail > *:last-child, .page-content > *:last-child, .comment-content > *:last-child, .author-bio > *:last-child, .widget-area > .widget > *:last-child {
    margin-bottom: 0;
}
.site-header > *:first-child, .entry-header > *:first-child, .post-thumbnail > *:first-child, .page-content > *:first-child, .comment-content > *:first-child, .author-bio > *:first-child, .widget-area > .widget > *:first-child {
    margin-top: 0;
}
.site-header > *:last-child, .entry-header > *:last-child, .post-thumbnail > *:last-child, .page-content > *:last-child, .comment-content > *:last-child, .author-bio > *:last-child, .widget-area > .widget > *:last-child {
    margin-bottom: 0;
}
.site-header > *:first-child, .entry-header > *:first-child, .post-thumbnail > *:first-child, .page-content > *:first-child, .comment-content > *:first-child, .author-bio > *:first-child, .widget-area > .widget > *:first-child {
    margin-top: 0;
}
.entry-title {
    font-size: 2.68832rem !important;
    letter-spacing: normal;
    line-height: 1.125 !important;
    color:#2d2d15;
    font-style: bold;
    text-align: center;
    margin-top: 50px;
    margin-bottom: 25px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.pedagogy-container{
  @media (min-width: 2559px) and (max-width: 3839px) {
    width: 762px !important; 
  }
  @media (min-width: 3840px) and (max-width: 4000px) {
    width: 880px !important; 
  }
}

.pedagogy-section {
  display: flex;
  justify-content: center;
}

.sticky-header {
  position: sticky;
  top: 0;
  z-index: 9;
}

.slider > div > div {
  height: auto !important;
  
  

  @media screen and (max-width: 320x) {
    min-height: 106px;
    width: auto;
  }
  @media screen and (max-width: 375px) {
    min-height: 150px;
    width: auto;
  }
  @media screen and (max-width: 425px) {
    min-height: 170px;
    width: 170px;
  }
  @media screen and (max-width: 768px) {
    min-height: 200px;
    width: auto;
  }
  
  @media (min-width: 769px) and (max-width: 1024px) {
    min-height: 406px;
    width: auto;
  }
  @media (min-width: 1025px) and (max-width: 4000px) {
    min-height: 406px;
    width: auto;
  }
  
}

.slider > div {
  height: auto !important;
  
 
  @media screen and (max-width: 320x) {
    min-height: 106px;
    width: auto;
  }
  @media screen and (max-width: 375px) {
    min-height: 150px;
    width: auto;
  }
  @media screen and (max-width: 425px) {
    min-height: 170px;
    width: 170px;
  }
  @media screen and (max-width: 768px) {
    min-height: 200px;
    width: auto;
  }
  
  @media (min-width: 769px) and (max-width: 1024px) {
    min-height: 406px;
    width: auto;
  }
  @media (min-width: 1025px) and (max-width: 4000px) {
    min-height: 406px;
    width: auto;
  }
  
}

.slider > div > div .rsis-container div {
  object-fit: contain !important;
  background-size: contain !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
  background-color: white;
}

.our_training {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
  @media screen and (max-width: 768px) {
    padding: 0px;
  }
  
  @media (min-width: 769px) and (max-width: 1024px) {
    padding: 40px;
  }
  
  position: relative;
  min-height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.our_training p {
  position: relative;
  z-index: 2;
  color: #fff !important;
}

.our_training::after {
  position: absolute;
  content: '';
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 1;
}

.text-areas {
  display: flex;
  gap: 20px;
  color: #ffff;
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 65%;
  justify-content: space-between;
}

.text-areas div ul {
    font-weight: 600;
    font-size: 1.5rem;
}
.align-center{
  display: flex;
  justify-content: center;
}

/* Hide the scrollbar track when not needed */
.lni-table-section {
  @media screen and (min-width: 769px) {
    overflow-y: auto; /* or overflow-y: scroll; */
  }
 
}

/* Style the scrollbar */
.lni-table-section::-webkit-scrollbar {
  width: 8px; /* Adjust the width as needed */
}

/* Style the scrollbar track */
.lni-table-section::-webkit-scrollbar-track {
  background-color: #f1f1f1; /* Change the color as needed */
}

/* Style the scrollbar handle */
.lni-table-section::-webkit-scrollbar-thumb {
  background-color: #888; /* Change the color as needed */
}

table.chakra-table {
  border-color: var(--chakra-colors-chakra-border-color) !important;
  /* display: flex;
  justify-content: center; */
}

/* over all scroll */
::-webkit-scrollbar {
  width: 8px; /* Adjust the width as needed */
}
::-webkit-scrollbar-track {
  background-color: #f1f1f1; /* Change the color as needed */
}
::-webkit-scrollbar-thumb {
  background-color: #888; /* Change the color as needed */
}`, "",{"version":3,"sources":["webpack://./src/Site.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,WAAW;AACb;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;GACG,8BAA8B;AACjC;AACA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;AACA;EACE,UAAU;EACV,eAAe;AACjB;;;AAGA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB,GAAG,gBAAgB;EAC3C,qBAAqB,GAAG,YAAY;AACtC;AACA,gDAAgD;AAChD;EACE,aAAa;AACf;;AAEA,4CAA4C;AAC5C;EACE,wBAAwB,GAAG,gBAAgB;EAC3C,qBAAqB,GAAG,YAAY;AACtC;;AAEA;EACE,yDAA6C;EAC7C,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yDAA8C;EAC9C,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yDAAgD;EAChD,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yDAA8C;EAC9C,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yDAA+C;EAC/C,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;AAC7B;;;AAGA;EACE,yDAAmD;EACnD,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yDAA8C;EAC9C,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;AAC7B;;;AAGA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,yDAAwD;EACxD,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;;;;;;GAMG;AACH,UAAU;AACV;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;AACA,YAAY;AACZ;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;AACA,eAAe;EACb,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,qBAAqB;IACnB,gBAAgB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,qBAAqB;IACnB,gBAAgB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,qBAAqB;IACnB,gBAAgB;AACpB;;;AAGA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;;AAGA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;;EAEZ,mBAAmB;EACnB,gBAAgB;;EAEhB,yBAAyB;;EAEzB,qBAAqB;EACrB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;AACA,eAAe;AACf;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,mCAAmC;AACrC;;;AAGA;AACA;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,gCAAgC;IAChC,sBAAsB;IACtB,6BAA6B;IAC7B,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,4DAA4D;AAChE;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,uBAAuB;;;;EAIvB;IACE,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;;AAEF;;AAEA;EACE,uBAAuB;;;EAGvB;IACE,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;;AAEF;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,uCAAuC;EACvC,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,yDAA2C;EAC3C,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,MAAM;EACN,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,cAAc;EACd,8BAA8B;AAChC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA,6CAA6C;AAC7C;EACE;IACE,gBAAgB,EAAE,2BAA2B;EAC/C;;AAEF;;AAEA,wBAAwB;AACxB;EACE,UAAU,EAAE,+BAA+B;AAC7C;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB,EAAE,+BAA+B;AAC5D;;AAEA,+BAA+B;AAC/B;EACE,sBAAsB,EAAE,+BAA+B;AACzD;;AAEA;EACE,iEAAiE;EACjE;4BAC0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,UAAU,EAAE,+BAA+B;AAC7C;AACA;EACE,yBAAyB,EAAE,+BAA+B;AAC5D;AACA;EACE,sBAAsB,EAAE,+BAA+B;AACzD","sourcesContent":[".container {\n  display: flex !important;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  max-width: 700px;\n  width: 100%;\n  margin: auto;\n  padding: 30;\n}\n.container .form-data {\n  width: 70%;\n  border: 1px solid #dfdfdf;\n  padding: 20px;\n  border-radius: 5px;\n  background: #fff;\n}\n.container .form-data .form-label {\n  color: #000 !important;\n}\npre {\n  width: 70%;\n  color: #fff;\n  font-size: larger;\n}\n.Level{\n  margin-left: .9rem;\n  background-color: 'red';\n}\n\nbutton {\n   background: #0563b4 !important; \n}\n.form .field + p {\n  color: red;\n}\n\n.goto_login {\n  color: black;\n}\n.error-message {\n  color: red;\n  font-size: 12px;\n}\n\n\n.syllabus-settings-card {\n  max-height: 80vh;\n  overflow: scroll;\n  top: 15px;\n}\n.popover_submenu {\n  max-height: 500px;\n  overflow: scroll;\n  -ms-overflow-style: none;  /* IE and Edge */\n  scrollbar-width: none;  /* Firefox */\n}\n/* Hide scrollbar for Chrome, Safari and Opera */\n.popover_submenu::-webkit-scrollbar, .chakra-card::-webkit-scrollbar {\n  display: none;\n}\n\n/* Hide scrollbar for IE, Edge and Firefox */\n.chakra-card {\n  -ms-overflow-style: none;  /* IE and Edge */\n  scrollbar-width: none;  /* Firefox */\n}\n\n.aboutus {\n  background-image: url(\"./images/Aboutus.jpg\");\n  width: 100%;\n  height: 330px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n\n.academic {\n  background-image: url(\"./images/academic.jpg\");\n  width: 100%;\n  height: 330px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n\n.adaptation{\n  background-image: url(\"./images/adaptation.jpg\");\n  width: 100%;\n  height: 330px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n\n.pedagogy {\n  background-image: url(\"./images/pedagogy.jpg\");\n  width: 100%;\n  height: 330px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n\n.wellbeing {\n  background-image: url(\"./images/wellbeing.jpg\");\n  width: 100%;\n  height: 330px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n\n\n.communication {\n  background-image: url(\"./images/communication.jpg\");\n  width: 100%;\n  height: 330px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n\n.personal {\n  background-image: url(\"./images/personal.jpg\");\n  width: 100%;\n  height: 330px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n\n\n.overlay-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.video_tag {\n  object-fit: initial;\n  width: 100%;\n  height: 55vh;\n}\n\n.header_menu::before {\n  color: #757575;\n  content: \"\\2022\";\n  line-height: 1;\n  position: absolute;\n  top: 4px;\n  left: -14px;\n  font-size: 24px;\n  pointer-events: none;\n}\n\n.submenu_icon::after{\n  content: \"\\00a0\\25BC\";\n  font-size: 0.69444rem;\n}\n\n.program {\n  background-image: url(\"./images/our_program_banner.jpg\");\n  width: 100%;\n  height: 330px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n.footer-whatsapp {\n  display: flex;\n  align-items: center;\n}\n/* .footer {\n  width: 100%;\n  position: fixed;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n} */\n/* Home  */\n.homeComponent .home-content{\n  font-size: 30px;\n  text-align: center;\n}\n.logowithcontent{\nmargin: auto;\n}\n.logowithcontent p{\n  font-weight: 600;\n  font-size: 14px;\n}\n.logowithcontent img {\n  width: 350px;\n  margin: 12px auto;\n}\n.sub-heading{\nfont-size: 30px;\n  font-weight: 600;\n  margin-bottom: 15px;\n}\n.mission {\n  width: 70%;\n  letter-spacing: 1.5px;\n  line-height: 1.6;\n}\n.vision {\n  font-size: 36px;\n  text-align: center;\n  margin: auto;\n  width: 90%;\n  letter-spacing: 1.5px;\n    line-height: 1.6;\n}\n\n.gray-block {\n  font-size: 28px;\n  text-align: center;\n  margin: auto;\n  width: 85%;\n  /* height: 300px; */\n  letter-spacing: 1.5px;\n    line-height: 1.6;\n}\n\n.ped-block {\n  font-size: 23px;\n  text-align: center;\n  margin: auto;\n  width: 85%;\n  height: 250px;\n  letter-spacing: 1.5px;\n    line-height: 1.6;\n}\n\n\n.imgBox {\n  font-size: 36px;\n  text-align: center;\n  margin: auto;\n  height: 60px;\n  width: 70%;\n  background-color: #000000;\n  letter-spacing: 1.5px;  \n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  font-weight: bold;\n}\n\n\n.imgBoxV2 {\n  font-size: 36px;\n  text-align: center;\n  margin: auto;\n  height: 60px;\n  width: 90%;\n  background-color: #000000;\n  letter-spacing: 1.5px;  \n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  font-weight: bold;\n}\n\n.progBox {\n  font-size: 36px;\n  text-align: center;\n  margin: auto;\n\n  /* height: 150px; */\n  /* width: 72%; */\n\n  background-color: #000000;\n  \n  letter-spacing: 1.5px;  \n  /* display: inline-block; */\n  vertical-align: middle;\n}\n\n.vision-section {\n  background-color: #4c4c47;\n  color: #fff;\n}\n.mission-points{\nfont-size: 14px;\n}\n\n.text-header {\n  /* font-size: 50px !important; */\n  letter-spacing: 2px !important;\n  /* font-style: normal !important; */\n}\n\n\nelement.style {\n}\n.site-header > *:last-child, .entry-header > *:last-child, .post-thumbnail > *:last-child, .page-content > *:last-child, .comment-content > *:last-child, .author-bio > *:last-child, .widget-area > .widget > *:last-child {\n    margin-bottom: 0;\n}\n.site-header > *:first-child, .entry-header > *:first-child, .post-thumbnail > *:first-child, .page-content > *:first-child, .comment-content > *:first-child, .author-bio > *:first-child, .widget-area > .widget > *:first-child {\n    margin-top: 0;\n}\n.site-header > *:last-child, .entry-header > *:last-child, .post-thumbnail > *:last-child, .page-content > *:last-child, .comment-content > *:last-child, .author-bio > *:last-child, .widget-area > .widget > *:last-child {\n    margin-bottom: 0;\n}\n.site-header > *:first-child, .entry-header > *:first-child, .post-thumbnail > *:first-child, .page-content > *:first-child, .comment-content > *:first-child, .author-bio > *:first-child, .widget-area > .widget > *:first-child {\n    margin-top: 0;\n}\n.entry-title {\n    font-size: 2.68832rem !important;\n    letter-spacing: normal;\n    line-height: 1.125 !important;\n    color:#2d2d15;\n    font-style: bold;\n    text-align: center;\n    margin-top: 50px;\n    margin-bottom: 25px;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.pedagogy-container{\n  @media (min-width: 2559px) and (max-width: 3839px) {\n    width: 762px !important; \n  }\n  @media (min-width: 3840px) and (max-width: 4000px) {\n    width: 880px !important; \n  }\n}\n\n.pedagogy-section {\n  display: flex;\n  justify-content: center;\n}\n\n.sticky-header {\n  position: sticky;\n  top: 0;\n  z-index: 9;\n}\n\n.slider > div > div {\n  height: auto !important;\n  \n  \n\n  @media screen and (max-width: 320x) {\n    min-height: 106px;\n    width: auto;\n  }\n  @media screen and (max-width: 375px) {\n    min-height: 150px;\n    width: auto;\n  }\n  @media screen and (max-width: 425px) {\n    min-height: 170px;\n    width: 170px;\n  }\n  @media screen and (max-width: 768px) {\n    min-height: 200px;\n    width: auto;\n  }\n  \n  @media (min-width: 769px) and (max-width: 1024px) {\n    min-height: 406px;\n    width: auto;\n  }\n  @media (min-width: 1025px) and (max-width: 4000px) {\n    min-height: 406px;\n    width: auto;\n  }\n  \n}\n\n.slider > div {\n  height: auto !important;\n  \n \n  @media screen and (max-width: 320x) {\n    min-height: 106px;\n    width: auto;\n  }\n  @media screen and (max-width: 375px) {\n    min-height: 150px;\n    width: auto;\n  }\n  @media screen and (max-width: 425px) {\n    min-height: 170px;\n    width: 170px;\n  }\n  @media screen and (max-width: 768px) {\n    min-height: 200px;\n    width: auto;\n  }\n  \n  @media (min-width: 769px) and (max-width: 1024px) {\n    min-height: 406px;\n    width: auto;\n  }\n  @media (min-width: 1025px) and (max-width: 4000px) {\n    min-height: 406px;\n    width: auto;\n  }\n  \n}\n\n.slider > div > div .rsis-container div {\n  object-fit: contain !important;\n  background-size: contain !important;\n  background-repeat: no-repeat !important;\n  background-position: center !important;\n  background-color: white;\n}\n\n.our_training {\n  background-image: url(\"./images/a3_bg.jpg\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-attachment: fixed;\n  @media screen and (max-width: 768px) {\n    padding: 0px;\n  }\n  \n  @media (min-width: 769px) and (max-width: 1024px) {\n    padding: 40px;\n  }\n  \n  position: relative;\n  min-height: 600px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.our_training p {\n  position: relative;\n  z-index: 2;\n  color: #fff !important;\n}\n\n.our_training::after {\n  position: absolute;\n  content: '';\n  height: 100%;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  top: 0;\n  left: 0;\n  z-index: 1;\n}\n\n.text-areas {\n  display: flex;\n  gap: 20px;\n  color: #ffff;\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  max-width: 65%;\n  justify-content: space-between;\n}\n\n.text-areas div ul {\n    font-weight: 600;\n    font-size: 1.5rem;\n}\n.align-center{\n  display: flex;\n  justify-content: center;\n}\n\n/* Hide the scrollbar track when not needed */\n.lni-table-section {\n  @media screen and (min-width: 769px) {\n    overflow-y: auto; /* or overflow-y: scroll; */\n  }\n \n}\n\n/* Style the scrollbar */\n.lni-table-section::-webkit-scrollbar {\n  width: 8px; /* Adjust the width as needed */\n}\n\n/* Style the scrollbar track */\n.lni-table-section::-webkit-scrollbar-track {\n  background-color: #f1f1f1; /* Change the color as needed */\n}\n\n/* Style the scrollbar handle */\n.lni-table-section::-webkit-scrollbar-thumb {\n  background-color: #888; /* Change the color as needed */\n}\n\ntable.chakra-table {\n  border-color: var(--chakra-colors-chakra-border-color) !important;\n  /* display: flex;\n  justify-content: center; */\n}\n\n/* over all scroll */\n::-webkit-scrollbar {\n  width: 8px; /* Adjust the width as needed */\n}\n::-webkit-scrollbar-track {\n  background-color: #f1f1f1; /* Change the color as needed */\n}\n::-webkit-scrollbar-thumb {\n  background-color: #888; /* Change the color as needed */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
